module.exports = __webpack_public_path__ + "img/manda_034.b8e6bc2f.png";